import React from 'react';
import { UseFieldArrayPrepend, useFormContext } from 'react-hook-form';
import {
  WaitlistForm,
  WaitlistParticipantForm,
} from '@/features/public/waitlist/schemas/waitlistSchema.ts';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card.tsx';
import { TextInput } from '@/components/form/TextInput.tsx';
import TwoInputsRow from '@/components/form/ui/TwoInputsRow.tsx';
import { DateInput } from '@/components/form/DateInput.tsx';
import CacPhoneInput from '@/components/form/CacPhoneInput.tsx';
import ToggleInput from '@/components/form/ToggleInput.tsx';

const getEmptyParticipant = (): WaitlistParticipantForm => ({
  firstName: '',
  lastName: '',
  birthDate: undefined as unknown as Date,
});

const WaitlistClientForm = ({
  insertParticipant,
  removeParticipant,
}: {
  insertParticipant: UseFieldArrayPrepend<WaitlistForm, 'participants'>;
  removeParticipant: (index: number) => void;
}) => {
  const {
    control,
    register,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext<WaitlistForm>();

  const onFillerTypeChange = (value: string) => {
    if (value === 'participant') {
      insertParticipant({
        ...getEmptyParticipant(),
        firstName: getValues('firstName'),
        lastName: getValues('lastName'),
        birthDate: getValues('birthDate'),
      });
    } else {
      removeParticipant(0);
    }
  };

  const onFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (getValues('fillerType') === 'participant') {
      setValue('participants.0.firstName', e.target.value);
    }
  };

  const onLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (getValues('fillerType') === 'participant') {
      setValue('participants.0.lastName', e.target.value);
    }
  };

  const onBirthDateChange = (date: Date | undefined) => {
    if (getValues('fillerType') === 'participant') {
      setValue('participants.0.birthDate', date);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Osoba rezerwująca</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 p-4">
        <ToggleInput
          fieldPath="fillerType"
          label="Formularz wypełnia"
          options={[
            { label: 'Osoba nie biorąca udziału', value: 'client' },
            { label: 'Uczestnik', value: 'participant' },
          ]}
          control={control}
          onChange={onFillerTypeChange}
          required
        />
        <TwoInputsRow>
          <TextInput
            label="Imię"
            register={register('firstName')}
            placeholder="Wpisz imię..."
            required
            error={errors.firstName?.message}
            onChange={onFirstNameChange}
          />
          <TextInput
            label="Nazwisko"
            register={register('lastName')}
            placeholder="Wpisz nazwisko..."
            required
            error={errors.lastName?.message}
            onChange={onLastNameChange}
          />
        </TwoInputsRow>
        <DateInput
          label="Data urodzenia"
          dateFieldName="birthDate"
          control={control}
          required
          onChange={onBirthDateChange}
        />
        <TextInput
          label="Adres e-mail"
          register={register('email')}
          placeholder="Wpisz adres e-mail..."
          required
          error={errors.email?.message}
        />
        <CacPhoneInput
          label="Numer telefonu"
          fieldPath="phoneNumber"
          error={errors.phoneNumber?.message}
        />
      </CardContent>
    </Card>
  );
};

export default WaitlistClientForm;
